fragment RestApiUserFragment on RestApiUser {
    id
    username
    password
}